/* LEVYPAW US Build 02 — Shopify predictive product search, native search fallback. */
(function () {
  'use strict';
  function init(container) {
    (container || document).querySelectorAll('form[data-lp-predictive]').forEach(function (form) {
      if (form.dataset.lpReady) return;
      form.dataset.lpReady = 'true';
      var input = form.querySelector('input[name="q"]');
      var panel = form.querySelector('.lp-us-suggest');
      if (!input || !panel || !window.fetch) return;
      var timer, controller;
      var endpoint = (form.dataset.predictiveUrl || '/search/suggest').replace(/\/$/, '');
      if (!endpoint.endsWith('.json')) endpoint += '.json';
      function hide() {
        panel.hidden = true;
        panel.replaceChildren();
        input.setAttribute('aria-expanded', 'false');
      }
      function show() {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
      function allLink(q) {
        var u = new URL(form.action, window.location.href);
        u.searchParams.set('q', q);
        u.searchParams.set('type', 'product');
        return u.pathname + u.search;
      }
      function node(tag, text, className) {
        var el = document.createElement(tag);
        if (text != null) el.textContent = text;
        if (className) el.className = className;
        return el;
      }
      function render(products, q) {
        panel.replaceChildren();
        panel.appendChild(node('div', products.length ? 'Matching designs' : 'No matches yet — try another breed.', 'lp-us-suggest__heading'));
        products.slice(0, 5).forEach(function (product) {
          if (!product || typeof product.url !== 'string' || !product.url.startsWith('/')) return;
          var a = node('a', product.title || 'View design', 'lp-us-suggest__item');
          a.href = product.url;
          panel.appendChild(a);
        });
        var all = node('a', 'See all results for “' + q + '” →', 'lp-us-suggest__all');
        all.href = allLink(q);
        panel.appendChild(all);
        show();
      }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (controller) controller.abort();
        hide();
        if (q.length < 2) return;
        timer = setTimeout(function () {
          controller = new AbortController();
          var url;
          try { url = new URL(endpoint, document.baseURI); }
          catch (e) { return; }
          url.searchParams.set('q', q);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '5');
          fetch(url.toString(), {signal: controller.signal, headers: {'Accept':'application/json'}})
            .then(function (res) { if (!res.ok) throw Error('suggestions unavailable'); return res.json(); })
            .then(function (data) {
              if (input.value.trim() !== q) return;
              var products = (((data || {}).resources || {}).results || {}).products || [];
              render(Array.isArray(products) ? products : [], q);
            })
            .catch(function () { if (input.value.trim() === q) hide(); });
        }, 250);
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') hide();
        if (event.key === 'ArrowDown' && !panel.hidden) {
          var first = panel.querySelector('a');
          if (first) { event.preventDefault(); first.focus(); }
        }
      });
      panel.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { hide(); input.focus(); }
      });
      form.addEventListener('submit', function () { hide(); });
      document.addEventListener('click', function (event) { if (!form.contains(event.target)) hide(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
